import endpoints from "../config/endpoints";
import api from "../config/axios";


export const InitPayment = async (data) => {
    try {
        const response = await api.post(endpoints.Payment.InitPayment, data);
        return {
            data: response.data.data || null,
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        }
    } catch (error) {
        console.error("Error initializing payment (InitPaymentAsync):", error.response?.data || error.message);
        throw error;
    }
};

export const VerifyPayment = async (paymentData) => {
    try {
        const response = await api.post(endpoints.Payment.VerifyPaymentAndCreateOrder, paymentData);
        return {
            data: response.data.data || null,
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        }
    } catch (error) {
        console.error("Error verifying payment:", error.response?.data || error.message);
        throw error;
    }
};

export const FetchSavedCards = async (customerId) => {
    try {
        const response = await api.get(`${endpoints.Payment.FetchSavedCards}?customerId=${customerId}`);
        return {
            data: response.data.data || null,
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        }
    } catch (error) {
        console.error("Error fetching cards:", error.response?.data || error.message);
        throw error;
    }
};

export const DeleteSavedToken = async (customerId, tokenId) => {
    try {
        const response = await api.delete(
            `${endpoints.Payment.DeleteSavedToken}?customerId=${customerId}&tokenId=${tokenId}`
        );
        return {
            data: response.data.data || null,
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error(
            "Error deleting saved payment token:",
            error.response?.data || error.message
        );
        throw error;
    }
};

export const PaymentCOD = async (data) => {
    try {
        const response = await api.post(endpoints.Payment.PaymentCOD, data);
        return {
            data: response.data.data || null,
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        }
    } catch (error) {
        console.error("Error initializing COD payment:", error.response?.data || error.message);
        throw error;
    }
};
